<template>
  <div :class="containerClasses">
    <!-- Icon or custom slot -->
    <div v-if="$slots.icon || icon" class="mb-3">
      <slot name="icon">
        <component :is="icon" :class="iconClasses" />
      </slot>
    </div>

    <!-- Title -->
    <h3 v-if="title || $slots.title" class="text-base font-semibold text-gray-900 dark:text-white mb-1">
      <slot name="title">{{ title }}</slot>
    </h3>

    <!-- Description -->
    <p v-if="description || $slots.description" class="text-sm text-gray-500 dark:text-gray-400 mb-4">
      <slot name="description">{{ description }}</slot>
    </p>

    <!-- Action buttons -->
    <div v-if="$slots.actions" class="flex items-center justify-center gap-2">
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  icon: {
    type: Object,
    default: null
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value)
  },
  compact: {
    type: Boolean,
    default: false
  }
})

const containerClasses = computed(() => {
  const classes = ['flex flex-col items-center justify-center text-center']

  if (!props.compact) {
    const sizes = {
      sm: 'py-8',
      md: 'py-12',
      lg: 'py-16'
    }
    classes.push(sizes[props.size])
  } else {
    classes.push('py-6')
  }

  return classes.join(' ')
})

const iconClasses = computed(() => {
  const sizes = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-20 h-20'
  }
  return `${sizes[props.size]} text-gray-400 dark:text-gray-600`
})
</script>
